var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.businessOrder.pallets.length
        ? _c(
            "collapsible-block",
            {
              ref: "collapsible",
              staticClass: "handling-units",
              attrs: {
                "title-text": _vm.$t("businessOrders.labels.handlingUnits"),
                disabled: !_vm.isVisible,
                collapsed: !_vm.isVisible
              }
            },
            [
              _vm.isVisible
                ? _vm._l(_vm.packagesWithDimensions, function(
                    handlingUnit,
                    index
                  ) {
                    return _c(
                      "div",
                      { key: index, staticClass: "flex--no-wrap" },
                      [
                        _c(
                          "h3",
                          { staticClass: "handling-units__heading-subsection" },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t(
                                    "businessOrders.labels.handlingUnit.name",
                                    { no: index + 1 }
                                  )
                                ) +
                                "\n                "
                            )
                          ]
                        ),
                        _c(
                          "flex-row",
                          {
                            staticClass: "flex--no-wrap",
                            attrs: { "column-spacing": "lg" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "col handling-units__measurements"
                              },
                              [
                                _c(
                                  "value-wrapper",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "businessOrders.labels.handlingUnit.weight"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(handlingUnit.weight + " lbs.") +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "col handling-units__measurements"
                              },
                              [
                                _c("div", {
                                  staticClass:
                                    "handling-units__vertical-separator"
                                })
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "col handling-units__measurements"
                              },
                              [
                                _c(
                                  "value-wrapper",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "businessOrders.labels.handlingUnit.length"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(handlingUnit.length + " in.") +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "col handling-units__measurements"
                              },
                              [
                                _c(
                                  "value-wrapper",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "businessOrders.labels.handlingUnit.width"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(handlingUnit.width + " in.") +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "col handling-units__measurements"
                              },
                              [
                                _c(
                                  "value-wrapper",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "businessOrders.labels.handlingUnit.height"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(handlingUnit.height + " in.") +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "col handling-units__measurements"
                              },
                              [
                                _c(
                                  "value-wrapper",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "businessOrders.labels.trackingNumber"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(handlingUnit.trackingNumber) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "handling-units__sku-table stick-to-modal-sides"
                          },
                          [
                            _c("order-package-items", {
                              attrs: {
                                "package-items": handlingUnit.items,
                                "stick-to-sides": "",
                                "business-order": _vm.businessOrder,
                                "sku-prefix": index.toString()
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm.isVisible && _vm.businessOrder.pallets.length > 0
        ? _vm._l(_vm.palletsWithDimensions, function(pallet, index) {
            return _c(
              "div",
              { key: index, staticClass: "flex--no-wrap" },
              [
                _c(
                  "collapsible-block",
                  {
                    staticClass: "pallet-unit",
                    attrs: {
                      "title-text": _vm.$t(
                        "businessOrders.labels.pallet.name",
                        { no: index + 1 }
                      ),
                      collapsed: false
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "v-spacing-sm" },
                      [
                        _c(
                          "flex-row",
                          {
                            staticClass: "flex--no-wrap",
                            attrs: { "column-spacing": "lg" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col col--wrap-text" },
                              [
                                _c(
                                  "value-wrapper",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "businessOrders.labels.trackingNumber"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm._f("valueOrDash")(pallet.tracking)
                                        ) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col col--wrap-text" },
                              [
                                _c(
                                  "value-wrapper",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "businessOrders.labels.pallet.dimensions"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm._f("valueOrDash")(
                                            pallet.dimensions
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col" },
                              [
                                _c(
                                  "value-wrapper",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "businessOrders.labels.pallet.ratedWeight"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm._f("valueOrDash")(pallet.weight)
                                        ) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    pallet.packages &&
                    pallet.packages.some(function(x) {
                      return (
                        x.palletizationType == 1 ||
                        (x.palletizationType == null &&
                          x.dimensions != _vm.zeroDims)
                      )
                    })
                      ? _c(
                          "h2",
                          {
                            staticClass:
                              "heading-with-separator pallet-section-header"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "heading-with-separator__inner" },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "businessOrders.labels.pallet.cartons"
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._l(
                      pallet.packages.filter(function(x) {
                        return (
                          x.palletizationType == 1 ||
                          (x.palletizationType == null &&
                            x.dimensions != _vm.zeroDims)
                        )
                      }),
                      function(palletPackage, skuIndex) {
                        return _c(
                          "div",
                          { key: skuIndex, staticClass: "flex--no-wrap" },
                          [
                            _c(
                              "div",
                              { staticClass: "pallet-unit__pallet-carton" },
                              [
                                _c("table", { staticClass: "table" }, [
                                  _c("thead", [
                                    _c(
                                      "tr",
                                      { staticClass: "table__header-row" },
                                      [
                                        _c(
                                          "th",
                                          { staticClass: "table__header-cell" },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "businessOrders.labels.pallet.cartonDimensions"
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]),
                                  _c("tbody", [
                                    _c(
                                      "tr",
                                      { staticClass: "table__body-row" },
                                      [
                                        _c(
                                          "td",
                                          { staticClass: "table__body-cell" },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm._f("valueOrDash")(
                                                    palletPackage.dimensions
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "pallet-unit__pallet-carton-skus"
                              },
                              [
                                _c("order-package-items", {
                                  attrs: {
                                    "package-items": palletPackage.items,
                                    "stick-to-sides": false,
                                    "business-order": _vm.businessOrder,
                                    "sku-prefix": skuIndex.toString()
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      }
                    ),
                    pallet.packages &&
                    pallet.packages.some(function(x) {
                      return (
                        x.palletizationType == 2 ||
                        (x.palletizationType == null &&
                          x.dimensions == _vm.zeroDims)
                      )
                    })
                      ? _c(
                          "h2",
                          {
                            staticClass:
                              "heading-with-separator pallet-section-header"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "heading-with-separator__inner" },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "businessOrders.labels.pallet.items"
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    pallet.packages &&
                    pallet.packages.some(function(x) {
                      return (
                        x.palletizationType == 2 ||
                        (x.palletizationType == null &&
                          x.dimensions == _vm.zeroDims)
                      )
                    })
                      ? _c("div", { staticClass: "flex--no-wrap" }, [
                          _c(
                            "div",
                            { staticClass: "pallet-unit__pallet-skus" },
                            [
                              _c("order-package-items", {
                                attrs: {
                                  "package-items": pallet.packages.find(
                                    function(x) {
                                      return (
                                        x.palletizationType == 2 ||
                                        (x.palletizationType == null &&
                                          x.dimensions == _vm.zeroDims)
                                      )
                                    }
                                  ).items,
                                  "stick-to-sides": false,
                                  "business-order": _vm.businessOrder,
                                  "sku-prefix": "withItems_"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ],
                  2
                )
              ],
              1
            )
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }